import { render, staticRenderFns } from "./SayfaDetay.vue?vue&type=template&id=1ff8d8f4&scoped=true&"
import script from "./SayfaDetay.vue?vue&type=script&lang=js&"
export * from "./SayfaDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8d8f4",
  null
  
)

export default component.exports